import gql from 'graphql-tag';

export const DigitalBundleDetails = gql`
  fragment DigitalBundleDetails on DigitalBundle {
    id
    is_active
    photos_count
    requires_package_purchase
    price {
      value
      currency
    }
    album_folder {
      id
    }
    account {
      id
      organization_name
    }
  }
`;

export const PurchasedDigitalBundleDetails = gql`
  fragment PurchasedDigitalBundleDetails on PurchasedDigitalBundle {
    id
    identity {
      id
      name
      last_name
      has_outdated_selfie
      relationship
      current_photo {
        id
        thumbnail_urls {
          url
          width
          height
          size_code
        }
      }
    }
    digital_bundle {
      ...DigitalBundleDetails
    }
    photos {
      total
    }
    photos_count
    status
  }
  ${DigitalBundleDetails}
`;
